import * as React from "react";
import { SingleScrollContainer, NormalContainer, GridOneBaseBox, LeftIconArrow, RightsIconArrow, } from "./styles";
import { ProductCard } from "../../NormalProducts/ProductCard";
import { getCellWidthByGrid as getProductCardPosterWidth } from "../../../utils/size";
const _animationDuration = 1000;
class SwipeProduct extends React.Component {
    constructor() {
        super(...arguments);
        this.canClick = true;
        this.autoSwipe = false;
        this.countDown = 0;
        this.productCardWidth = getProductCardPosterWidth({
            contentWidth: this.props.gridWidth,
            gridCol: this.props.gridCol,
            gridGap: this.props.gridGap,
        });
        this.productsOnOnePage = this.props.gridCol * 1;
        this.state = {
            cIndex: 0,
            animationDuration: 0,
            needAdd: Math.ceil((this.productsOnOnePage * 3) / 2),
        };
        this.onBack = () => {
            if (!this.canClick || this.state.cIndex > 20) {
                return;
            }
            this.canClick = false;
            this.setState(state => ({
                cIndex: state.cIndex - this.productsOnOnePage,
                animationDuration: _animationDuration,
            }));
            this.props.onClickBack && this.props.onClickBack();
        };
        this.onNext = () => {
            if (!this.canClick) {
                return;
            }
            this.canClick = false;
            this.setState(state => ({
                cIndex: state.cIndex + this.productsOnOnePage,
                animationDuration: _animationDuration,
            }));
            this.props.onClickNext && this.props.onClickNext();
        };
        this.onTransitionEnd = () => {
            const { products } = this.props;
            const { cIndex, needAdd } = this.state;
            if (cIndex + needAdd > products.length + this.productsOnOnePage) {
                this.setState({
                    cIndex: cIndex - this.getOffset() - (products.length % this.productsOnOnePage),
                    animationDuration: 0,
                });
            }
            if (cIndex - this.productsOnOnePage < -needAdd) {
                this.setState({
                    cIndex: cIndex + this.getOffset() + (products.length % this.productsOnOnePage),
                    animationDuration: 0,
                });
            }
            this.canClick = true;
        };
        this.getOffset = () => {
            const { products } = this.props;
            return Math.floor(products.length / this.productsOnOnePage) * this.productsOnOnePage;
        };
        this.getSingleStyle = () => {
            const { cIndex, animationDuration, needAdd } = this.state;
            const style = {};
            style.width = `${this.getNodeCount()}00%`;
            const wrapperOffsetLeft = -1 * (cIndex + needAdd) * (this.productCardWidth + this.props.gridGap);
            style.transform = `translate3d(${wrapperOffsetLeft}px,0,0)`;
            style.transitionDuration = `${animationDuration}ms`;
            style.WebkitTransform = style.transform;
            style.transitionTimingFunction = "ease-out";
            return style;
        };
        this.renderCard = (product, index) => {
            const { gridWidth: width, posterRatio, gridCol, gridGap, layoutStyle, placeholderBg, scoreOptions, smartImageProps, onClick, } = this.props;
            const productCardWidth = +((width - gridGap * (gridCol - 1)) / gridCol).toFixed(1);
            return (React.createElement(ProductCard, { key: index, product: Object.assign({}, product), width: `${productCardWidth}px`, posterRatio: posterRatio, gridCol: gridCol, layoutStyle: layoutStyle, collectOptions: scoreOptions, smartImageProps: smartImageProps, onClick: () => onClick && onClick((index + 1).toString(), product.gpid), placeholderBg: placeholderBg }));
        };
        this.renderProductContent = () => {
            const { products } = this.props;
            const { needAdd } = this.state;
            if (products.length === 5) {
                return (React.createElement(React.Fragment, null,
                    products
                        .slice(-1)
                        .map((product, index) => this.renderCard(product, index - 6)),
                    products.map((product, index) => this.renderCard(product, index - 5)),
                    products.map((product, index) => this.renderCard(product, index)),
                    products.map((product, index) => this.renderCard(product, index + products.length)),
                    products
                        .slice(0, 1)
                        .map((product, index) => this.renderCard(product, index + products.length + 1))));
            }
            return (React.createElement(React.Fragment, null,
                products.slice(-needAdd).map((product, index) => this.renderCard(product, index)),
                products.map((product, index) => this.renderCard(product, index)),
                products
                    .slice(0, needAdd)
                    .map((product, index) => this.renderCard(product, index))));
        };
    }
    getNodeCount() {
        const { products } = this.props;
        const { needAdd } = this.state;
        return products.length + needAdd * 2;
    }
    render() {
        const { products, handWheel } = this.props;
        if (products.length <= this.productsOnOnePage) {
            return (React.createElement(SingleScrollContainer, { gridWidth: this.productCardWidth, gridGap: this.props.gridGap }, products.map((product, index) => this.renderCard(product, index))));
        }
        return (React.createElement(NormalContainer, { gridWidth: this.props.gridWidth, onMouseEnter: () => (this.autoSwipe = false), onMouseLeave: () => (this.autoSwipe = true) },
            React.createElement(LeftIconArrow, Object.assign({}, handWheel, { onClick: this.onBack })),
            React.createElement(GridOneBaseBox, { gridWidth: this.productCardWidth, gridGap: this.props.gridGap, style: this.getSingleStyle(), onTransitionEnd: this.onTransitionEnd }, this.renderProductContent()),
            React.createElement(RightsIconArrow, Object.assign({}, handWheel, { onClick: this.onNext }))));
    }
}
SwipeProduct.defaultProps = {
    gridGap: 12,
};
export default SwipeProduct;
